import React from 'react';
import Box from './Box';

const Spacer = () => <Box margin="auto" />;

export default Spacer;
